export default {
    booleans: [
      {value:true,              text:{en:"True",       cn:"是",  }},  
      {value:false,             text:{en:"False",      cn:"否",  }}, 
    ],
  };
  